import { MarketResearchJobInsights, MarketResearchType } from "@relode/core";
import * as React from "react";

import {
    MarketResearchMarketing,
    MarketResearchUpSellMarketingSection,
} from "../../../../../src/shared/components";
import { useClientPublicJobContext } from "../_infra/clientPublicJobProvider";

export const ClientPublicJobMarketResearch = () => {
    const {
        state: {
            data: { token, job, marketResearch },
        },
        actions,
    } = useClientPublicJobContext();

    const handleLoadMarketResearchSummary = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.summary.data) return;
        await actions.loadMarketResearchSummary(token);
    };

    const handleLoadMarketResearchCompensation = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.compensation.data) return;
        await actions.loadMarketResearchCompensation(token);
    };

    const handleLoadMarketResearchSupplyDemand = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.supplyDemand.data) return;
        await actions.loadMarketResearchSupplyDemand(token);
    };

    const handleLoadMarketResearchDiversity = async () => {
        // no sorting or anything that could change this once loaded so ignore collapse/expand calls
        if (!!marketResearch.diversity.data) return;
        await actions.loadMarketResearchDiversity(token);
    };

    const showMarketing = !job.isSharedFromAdmin && job.canUpsellMarketResearch;

    if (showMarketing) {
        return (
            <MarketResearchMarketing
                jobManagerName={job.details?.jobManager?.name}
                jobManagerEmail={job.details?.jobManager?.email}
                jobManagerPhoneNumber={job.details?.jobManager?.phoneNumber}
            />
        );
    }

    return (
        <>
            {/* if admin shared, show marketResearch, but don't miss the opportunity to up sell! */}
            {job.isSharedFromAdmin && job.canUpsellMarketResearch ? (
                <MarketResearchUpSellMarketingSection
                    jobManagerName={job.details.jobManager.name}
                    jobManagerEmail={job.details.jobManager.email}
                    jobManagerPhoneNumber={job.details.jobManager.phoneNumber}
                />
            ) : null}
            <MarketResearchJobInsights
                jobId={job.details.jobId}
                state={marketResearch}
                marketResearchType={MarketResearchType.PublicJob}
                onLoadSummary={handleLoadMarketResearchSummary}
                onLoadCompensation={handleLoadMarketResearchCompensation}
                onLoadDiversity={handleLoadMarketResearchDiversity}
                onLoadSupplyDemand={handleLoadMarketResearchSupplyDemand}
            />
        </>
    );
};
